// RESIZE OBSERVER
if(window.innerWidth <= 767){
  var screenSize = 'small';
}
if(window.innerWidth > 767 && window.innerWidth < 992){
  var screenSize = 'medium';
}
if(window.innerWidth >= 992){
  var screenSize = 'large';
}

window.addEventListener('resize', function(event) {
  if(window.innerWidth <= 767 && screenSize != 'small'){
    location.reload();
  }
  if(window.innerWidth > 767 && window.innerWidth < 992 && screenSize != 'medium'){
    location.reload();
  }
  if(window.innerWidth >= 992 && screenSize != 'large'){
    location.reload();
  }
});